<template>
  <div>
    <el-row type="flex" class="my-2">
      <el-col :span="24">
        <div class="text-center">
          <p class="text-muted">
            {{ title }}
            <span v-if="identifier" class="text-black text-bold">{{
              identifier || "your identifier"
            }}</span>
          </p>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col :span="24">
        <el-form :model="form" label-position="top" ref="form">
          <el-form-item label="OTP" prop="otp" :rules="inputField()">
            <el-input
              v-model="form.otp"
              type="text"
              required
              @focus="changeColor($event)"
              @blur="resetColor($event)"
              v-only-number
            />
          </el-form-item>
        </el-form>

        <el-row type="flex">
          <el-col :span="24">
            <el-button
              class="authx-button w-100"
              type="primary"
              :disabled="timer > 0"
              :loading="verifying"
              @click="verify"
              >Verify</el-button
            >
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <p class="form-footer">
              Didn't get code?
              <span :class="{ disabled: timer > 0 }" @click="resendOtp"
                >Resend code <span v-if="timer > 0"> - {{ timer }}s</span>
              </span>
            </p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { currentUser } from "@/lib/utils";

export default {
  name: "NFormVerifyOtp",
  props: {
    title: {
      type: String,
      default: ""
    },
    identifier: {
      type: String,
      default: ""
    },
    token: {
      type: String,
      default: ""
    },
    domainData: {
      type: Object,
      default() {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      radiusUser: currentUser(),
      method: "",
      otpValue: "",
      form: {
        otp: ""
      },
      verifying: false,
      resending: false,
      step: 1,
      timer: null,
      vendorUserData: {}
    };
  },

  computed: {
    tokenValue: {
      get() {
        return this.token;
      },
      set(value) {
        this.$emit("update:token", value);
      }
    }
  },

  created() {
    setTimeout(() => {
      this.setPrimaryColour();
    });
  },

  methods: {
    resetColor(evt) {
      evt.target.style.borderColor = "#dcdfe6";
    },

    changeColor(evt) {
      evt.target.style.borderColor = this.colors.secondary;
    },

    setPrimaryColour() {
      const primaryColor = `${this.colors.primary}`;

      const buttons = document.querySelectorAll(
        ".authx-button.el-button--primary"
      );
      buttons.forEach(button => {
        button.style.background = primaryColor;
        button.style.borderColor = primaryColor;
      });
    },

    startTimer() {
      if (this.timer < 0) {
        return;
      }
      setTimeout(() => {
        this.timer--;
        this.startTimer();
      }, 1200);
    },

    resendOtp() {
      if (this.timer > 0) {
        return;
      }
      this.$refs.form.resetFields();
      this.timer = 10;
      this.startTimer();
      this.resending = true;

      this.$http
        .post(
          "apps/users/verification/send",
          {
            method: "POST"
          },
          {
            headers: {
              "Session-Token": this.domainData.sessionToken
            }
          }
        )
        .then(response => {
          this.resending = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.notification("OTP Code", "OTP resent successfully", "success");
            this.tokenValue = resData.data && resData.data.token;
          }
        })
        .catch(() => {
          this.resending = false;
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    verify() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }
        this.verifying = true;
        this.timer = 10;
        this.startTimer();

        const body = {
          token: this.tokenValue,
          pin: this.form.otp
        };

        this.$http
          .post(
            "apps/users/verify",
            {
              body: body,
              method: "POST"
            },
            {
              headers: {
                "Session-Token": this.domainData.sessionToken
              }
            }
          )
          .then(response => {
            this.verifying = false;
            const { status, data } = response.data;
            if (status === "error") {
              this.handleErrors(response.data);
            } else {
              this.$emit("next", data);
              this.notification(
                "Verified",
                "Account verified successfully",
                "success"
              );
            }
          })
          .catch(() => {
            this.verifying = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.form-footer {
  span {
    opacity: 1 !important;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5 !important;
    }
  }
}
</style>
